import React, { useState } from 'react';

import { useQueryClient } from 'react-query';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useMutationDeleteSegment } from 'api/mutations/deleteSegment.mutation';
import { Segment } from 'api/queries/getSegmentsList.query';

import { CustomizedConfirmDeleteModal } from 'components/common';

export const ConfirmDeleteSegment = ({
    segment,
    handleModalClose,
}: {
    segment: Segment | null;
    handleModalClose: () => void;
}) => {
    const { mutate: deleteSegment, isLoading } = useMutationDeleteSegment();
    const queryClient = useQueryClient();
    const { handleSnackBar } = useCustomSnackBar();

    const handleDeleteSegment = () => {
        if (segment) {
            deleteSegment(
                { segmentId: segment.segmentId },
                {
                    onSuccess: () => {
                        queryClient.invalidateQueries('getSegmentsList').then(() => {
                            handleSnackBar(`Segment deleted`, 'success');
                            handleModalClose();
                        });
                    },
                    onError: (error) => {
                        const message = 'Error deleting segment';
                        DEFAULT_ERROR({ error, message, handleError: handleSnackBar });
                    },
                    onSettled: () => {},
                },
            );
        }
    };

    return (
        <CustomizedConfirmDeleteModal
            onConfirm={handleDeleteSegment}
            hideModal={handleModalClose}
            isShowModal={Boolean(segment)}
            isLoading={isLoading}
            text={`Are you sure you want to delete this segment (${segment?.name})?`}
        />
    );
};
